import React from 'react';
import { MenuOption } from 'models/utils/common/menu/menu-option-model';
import { ReactComponent as CalloutDirectionSetterLeft } from 'icons/callouts-direction-setter-left.svg';
import { ReactComponent as CalloutDirectionSetterTop } from 'icons/callouts-direction-setter-top.svg';
import { ReactComponent as CalloutDirectionSetterRight } from 'icons/callouts-direction-setter-right.svg';
import { ReactComponent as CalloutDirectionSetterBottom } from 'icons/callouts-direction-setter-bottom.svg';
import { ReactComponent as CalloutResetIcon } from 'icons/restore.svg';

export const ANNOTATION_POSITION_TYPES = {
  LEFT: 1,
  TOP: 2,
  RIGHT: 3,
  BOTTOM: 4,
  RESET: 5,
};

export const REVERSE_ANNOTATION_POSITION_TYPES = Object.fromEntries(
  Object.entries(ANNOTATION_POSITION_TYPES).map(([key, value]) => [value, key]),
);

const ANNOTATION_SUMMARY_ICON_SIZE = '30px';

export const ANNOTATION_POSITION_OPTIONS_MAP = new Map();

ANNOTATION_POSITION_OPTIONS_MAP.set(
  ANNOTATION_POSITION_TYPES.LEFT,
  new MenuOption({
    id: ANNOTATION_POSITION_TYPES.LEFT,
    title: 'annotations-direction-left',
    value: ANNOTATION_POSITION_TYPES.LEFT,
    icon: (
      <CalloutDirectionSetterLeft
        width={ANNOTATION_SUMMARY_ICON_SIZE}
        height={ANNOTATION_SUMMARY_ICON_SIZE}
      />
    ),
    tooltip: {
      id: 'left-direction-tooltip-marker',
      title: 'annotations-direction-tooltip-message',
      position: 'left',
    },
  }),
);
ANNOTATION_POSITION_OPTIONS_MAP.set(
  ANNOTATION_POSITION_TYPES.TOP,
  new MenuOption({
    id: ANNOTATION_POSITION_TYPES.TOP,
    title: 'annotations-direction-top',
    value: ANNOTATION_POSITION_TYPES.TOP,
    icon: (
      <CalloutDirectionSetterTop
        width={ANNOTATION_SUMMARY_ICON_SIZE}
        height={ANNOTATION_SUMMARY_ICON_SIZE}
      />
    ),
    tooltip: {
      id: 'top-direction-tooltip-marker',
      title: 'annotations-direction-tooltip-message',
      position: 'left',
    },
  }),
);
ANNOTATION_POSITION_OPTIONS_MAP.set(
  ANNOTATION_POSITION_TYPES.RIGHT,
  new MenuOption({
    id: ANNOTATION_POSITION_TYPES.RIGHT,
    title: 'annotations-direction-right',
    value: ANNOTATION_POSITION_TYPES.RIGHT,
    icon: (
      <CalloutDirectionSetterRight
        width={ANNOTATION_SUMMARY_ICON_SIZE}
        height={ANNOTATION_SUMMARY_ICON_SIZE}
      />
    ),
    tooltip: {
      id: 'right-direction-tooltip-marker',
      title: 'annotations-direction-tooltip-message',
      position: 'left',
    },
  }),
);
ANNOTATION_POSITION_OPTIONS_MAP.set(
  ANNOTATION_POSITION_TYPES.BOTTOM,
  new MenuOption({
    id: ANNOTATION_POSITION_TYPES.BOTTOM,
    title: 'annotations-direction-bottom',
    value: ANNOTATION_POSITION_TYPES.BOTTOM,
    icon: (
      <CalloutDirectionSetterBottom
        width={ANNOTATION_SUMMARY_ICON_SIZE}
        height={ANNOTATION_SUMMARY_ICON_SIZE}
      />
    ),
    tooltip: {
      id: 'bottom-direction-tooltip-marker',
      title: 'annotations-direction-tooltip-message',
      position: 'left',
    },
  }),
);

export const RESET_ANNOTATION_OPTION = new MenuOption({
  id: ANNOTATION_POSITION_TYPES.RESET,
  title: 'annotations-direction-reset',
  value: ANNOTATION_POSITION_TYPES.RESET,
  className: 'reset-annotation-position',
  icon: (
    <CalloutResetIcon
      width={ANNOTATION_SUMMARY_ICON_SIZE}
      height={ANNOTATION_SUMMARY_ICON_SIZE}
    />
  ),
});

export const ANNOTATION_POSITIONS = Array.from(
  ANNOTATION_POSITION_OPTIONS_MAP.values(),
);

export const ANNOTATION_FONT_SIZE_TYPES = {
  XSMALL: 6,
  SMALL: 7,
  MEDIUM: 8,
  LARGE: 9,
  XLARGE: 10,
};
export const ANNOTATION_FONT_SIZE_MAP = new Map();
ANNOTATION_FONT_SIZE_MAP.set(
  ANNOTATION_FONT_SIZE_TYPES.XSMALL,
  new MenuOption({
    id: ANNOTATION_FONT_SIZE_TYPES.XSMALL,
    value: ANNOTATION_FONT_SIZE_TYPES.XSMALL,
    icon: 'A',
  }),
);
ANNOTATION_FONT_SIZE_MAP.set(
  ANNOTATION_FONT_SIZE_TYPES.SMALL,
  new MenuOption({
    id: ANNOTATION_FONT_SIZE_TYPES.SMALL,
    value: ANNOTATION_FONT_SIZE_TYPES.SMALL,
    icon: 'A',
  }),
);
ANNOTATION_FONT_SIZE_MAP.set(
  ANNOTATION_FONT_SIZE_TYPES.MEDIUM,
  new MenuOption({
    id: ANNOTATION_FONT_SIZE_TYPES.MEDIUM,
    value: ANNOTATION_FONT_SIZE_TYPES.MEDIUM,
    icon: 'A',
  }),
);
ANNOTATION_FONT_SIZE_MAP.set(
  ANNOTATION_FONT_SIZE_TYPES.LARGE,
  new MenuOption({
    id: ANNOTATION_FONT_SIZE_TYPES.LARGE,
    value: ANNOTATION_FONT_SIZE_TYPES.LARGE,
    icon: 'A',
  }),
);
ANNOTATION_FONT_SIZE_MAP.set(
  ANNOTATION_FONT_SIZE_TYPES.XLARGE,
  new MenuOption({
    id: ANNOTATION_FONT_SIZE_TYPES.XLARGE,
    value: ANNOTATION_FONT_SIZE_TYPES.XLARGE,
    icon: 'A',
  }),
);
export const ANNOTATION_FONT_SIZE = Array.from(
  ANNOTATION_FONT_SIZE_MAP.values(),
);
